import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = { class: "my-1" }
const _hoisted_3 = { class: "col fs-2" }
const _hoisted_4 = { class: "d-flex my-3" }
const _hoisted_5 = ["placeholder"]
const _hoisted_6 = { class: "h4 my-2" }
const _hoisted_7 = { class: "h5" }
const _hoisted_8 = { class: "h5" }
const _hoisted_9 = { class: "h5" }

import { computed, ref, withDefaults } from "vue";
import PageNation from "../../../../framework/components/table/PageNation.vue";
import { MessageDialog } from "../../../../framework/frontend/MessageDialog";
import { BlocklyService } from "../../../biz/remote/BlocklyService";
import { IdentifyFactory } from "../../../utils/IdentifyFactory";
import { SessionUser } from "../../../utils/SessionUser";
import { UserBlockContents } from "../../../../server/dto/generated/UserBlockContents";
import ListHeader from "../../../components/header/ListHeader.vue";
import { translation } from "../../../lang/Translation";

interface Prop {
  currentPage: number;
  title: string;
  rows: any[];
  pageSize: number;
  onPageChanged: (rowInPage: UserBlockContents[], currentPageNew: number) => void;
  onAddNew: (project_id: string) => void;
  onFilter: (condition: string) => void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ListTop',
  props: {
    currentPage: { default: 0 },
    title: { default: "list" },
    rows: { default: () => [] },
    pageSize: { default: 0 },
    onPageChanged: null,
    onAddNew: null,
    onFilter: null
  },
  setup(__props: any) {

const props = __props as { currentPage: number, title: string, rows: any[], pageSize: number, onPageChanged: (rowInPage: UserBlockContents[], currentPageNew: number) => void, onAddNew: (project_id: string) => void, onFilter: (condition: string) => void };



const t = translation;

const maxLength = computed(() => {
  return props.rows.length;
});

const maxPage = computed(() => {
  return Math.floor(props.rows.length / props.pageSize) + 1;
});

/**
 * フィルター
 */
const filterWords = ref("");
const projectFilter = computed({
  get: () => {
    return filterWords.value;
  },
  set: (value: string) => {
    filterWords.value = value;
    props.onFilter(value);
  },
});

// 新規プロジェクト作成
const addNewProject = async () => {
  const biz = new BlocklyService();
  const project_id = IdentifyFactory.instance.getUniqueStr();
  const title = t.to("名前のないプロジェクト", "project_default_title");
  await biz.addNewClassMemberContains(
    SessionUser.instance.userId,
    SessionUser.instance.memberId,
    project_id,
    title
  );
  MessageDialog.info(`id[${project_id}]${t.to("を作成しました", "list_created")}`);
  props.onAddNew(project_id);
};

// ページネイションの移動
const pageChanged = (rowInPage: UserBlockContents[], currentPageNew: number) => {
  props.onPageChanged(rowInPage, currentPageNew);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ListHeader),
    _createElementVNode("span", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, _toDisplayString(__props.title), 1),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          class: "btn btn-primary me-3",
          onClick: addNewProject
        }, _toDisplayString(_unref(t).to("あたらしくつくる", "list_addNewTitle")), 1),
        _withDirectives(_createElementVNode("input", {
          id: "filterText",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(projectFilter) ? (projectFilter).value = $event : null)),
          autocomplete: "off",
          name: "filterText",
          class: "form-controll col-4 px-2",
          style: {"border":"solid thin","border-radius":"5px","font-size":"larger"},
          placeholder: _unref(t).to('検索', 'list_filter')
        }, null, 8, _hoisted_5), [
          [_vModelText, _unref(projectFilter)]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(t).to("ページ", "list_currentPageSuffix")) + " " + _toDisplayString(__props.currentPage), 1),
      _createElementVNode("span", _hoisted_8, " / " + _toDisplayString(_unref(t).to("全ページ", "list_maxPageSuffix")) + " " + _toDisplayString(_unref(maxPage)), 1),
      _createElementVNode("span", _hoisted_9, " ( " + _toDisplayString(_unref(t).to("総数", "list_projectCountTitle")) + " " + _toDisplayString(_unref(maxLength)) + " ) ", 1),
      _createVNode(PageNation, {
        class: "my-2 h-5",
        "full-rows": __props.rows,
        "page-size": __props.pageSize,
        "on-page-changed": pageChanged
      }, null, 8, ["full-rows", "page-size"])
    ])
  ]))
}
}

})